import React from 'react'
import PropTypes from 'prop-types'
import ClientQuestionsPage from 'src/components/pages/ClientQuestions'
import ClientFaqService from 'src/services/ClientFaqService'
import ContentfulJsonLdBlocks from 'src/components/shared/ContentfulJsonLdBlocks'
import Layout from 'src/components/layouts'
import { getContentfulJsonLd } from 'src/common/getContentfulJsonLd'
import logger from 'src/common/logger'
import { getMegamenuData } from 'src/common/back/megamenu'

export async function getServerSideProps(context) {
  const { preview } = context
  const jsonLdSchemas = await getContentfulJsonLd('client-faq/')
  let megamenuData = null
  let clientQuestions = []
  try {
    clientQuestions = await ClientFaqService.getInstance().getClientQuestions(
      preview
    )
    megamenuData = await getMegamenuData(context)
  } catch (error) {
    logger.error('Client FAQ page: Leadership data error!', { error })
  }

  return {
    props: {
      clientQuestions,
      megamenuData: megamenuData || null,
      jsonLdSchemas,
    },
  }
}

const ClientQuestions = ({
  clientQuestions,
  megamenuData,
  jsonLdSchemas = null,
}) => (
  <>
    <ContentfulJsonLdBlocks jsonLdSchemas={jsonLdSchemas} />
    <Layout footerClassName="max-w-1400" megamenuData={megamenuData}>
      <ClientQuestionsPage clientQuestions={clientQuestions} />
    </Layout>
  </>
)

ClientQuestions.propTypes = {
  clientQuestions: PropTypes.array.isRequired,
  jsonLdSchemas: PropTypes.array,
}

export default ClientQuestions
